package `fun`.adaptive.ui.instruction.layout

enum class SplitVisibility {
    None,
    First,
    Second,
    Both
}